module.exports = __webpack_public_path__ + "img/nevs_level_D.252f37ef.png";